
import { faMapMarkerAlt, faMapSigns } from '@fortawesome/pro-regular-svg-icons'
import { get } from 'lodash'

export default {
  name: 'Address',

  props: {
    location: {
      type: Object,
      default: () => ({})
    },

    copyOnly: {
      type: Boolean,
      default: false
    },

    allowCopy: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    compLocation() {
      const locationParsed = { ...this.location }

      locationParsed.fullAddress = ''

      if (this.location.addressLine1) {
        locationParsed.fullAddress += `${this.location.addressLine1}, `
      }

      if (this.location.addressLine2) {
        locationParsed.fullAddress += `${this.location.addressLine2}, `
      }

      if (this.location.addressLocality) {
        locationParsed.fullAddress += `${this.location.addressLocality}, `
      }

      if (this.location.addressRegion) {
        locationParsed.fullAddress += `${this.location.addressRegion}, `
      }

      if (this.location.addressCode) {
        locationParsed.fullAddress += `${this.location.addressCode}`
      }

      // Remove the last comma and any whitespace after it
      locationParsed.fullAddress = locationParsed.fullAddress.replace(/,\s*$/, '')

      locationParsed.lngLatArray = get(this.location, 'latitude', '')

      return locationParsed
    },

    compCopyOptions() {
      const copyActions = [
        {
          label: this.$t('copyFullAddress'),
          prefixIcon: faMapSigns,
          onClick: () => {
            this.copyAddress()
            this.$analytics.addEvent('Used CopyPaste', { option: 'Full address' })
          }
        },

        {
          label: this.$t('copyCoordinates'),
          prefixIcon: faMapMarkerAlt,
          onClick: () => {
            this.copyCoordinates()
            this.$analytics.addEvent('Used CopyPaste', { option: 'Coordinates' })
          }
        }
      ]

      return copyActions.filter(action => action.isActive || !('isActive' in action))
    }
  },

  methods: {
    copyAddress() {
      this.$copyToClipboard(this.compLocation.fullAddress)
    },

    copyCoordinates() {
      this.$copyToClipboard(this.compLocation.lngLatArray.slice().reverse().join(','))
    }
  }
}
